import React from 'react';
import AnimatedCRMMockup from './AnimatedCRMMockup';

// Keep video URLs for backwards compatibility if needed
const videos = [
  'https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/video-content/1.mp4',
  'https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/video-content/Untitled%20design%20(6).mp4',
  'https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/video-content/Untitled%20design%20(7).mp4',
  'https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/video-content/4.mp4',
  'https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/video-content/Untitled%20design%20(3).mp4',
  'https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/video-content/3.mp4',
];

interface VideoBentoProps {
  activeTab: number;
  customBrand?: {
    name: string;
    icon?: React.ReactNode;
  };
}

const VideoBento: React.FC<VideoBentoProps> = ({ activeTab, customBrand }) => {
  return <AnimatedCRMMockup activeTab={activeTab} customBrand={customBrand} />;
};

export { videos };
export default VideoBento;
